import { BankAccountScheme } from '@40seas/entities/bank-account';
import { EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { BaseEntity, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';

export const AirwallexRecipientSchema = WithBaseEntitySchema(
    z.object({
        providerId: z.string(),
        accountId: z.string(),
        bankAccount: z.string(),
        bankAccountScheme: EnumSchema(BankAccountScheme).nullish(),
    }),
).strict();

export class AirwallexRecipient extends FromSchema(AirwallexRecipientSchema) implements BaseEntity {
    id: string;
    providerId: string;
    accountId: string;
    bankAccount: string;
    bankAccountScheme?: BankAccountScheme;
    createdAt: Date;
    updatedAt: Date;
    createdBy?: Executor;
    tenantId: string;
    seller?: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
